import React from 'react';
import { SpinnerLoaderSizes } from '../spinner-loader';
import { ContentButtonWithIcon } from './ContentButtonWithIcon';
import { CONTAINED_VARIANT, DEFAULT_BUTTON_PROPS, FADED_VARIANT, GHOST_VARIANT, NO_ICON, TEXT_VARIANT, } from './constants';
import { ButtonContained, ButtonFaded, ButtonGhost, ButtonText, SpinnerLoaderStyled, } from './styled';
// This is helper better left in this file to prevent issue with 'Dependency cycle"
const getButtonComponent = ({ buttonVariant }) => {
    const component = {
        [CONTAINED_VARIANT]: ButtonContained,
        [GHOST_VARIANT]: ButtonGhost,
        [FADED_VARIANT]: ButtonFaded,
        [TEXT_VARIANT]: ButtonText,
    };
    return component[buttonVariant];
};
/**
 * @param buttonVariant (default - CONTAINED_VARIANT); CONTAINED_VARIANT | GHOST_VARIANT | FADED_VARIANT | TEXT_VARIANT
 * @param label (Text for button); optional;
 * @param onClick fn eventHandler
 * @param isHovered boolean; default - false
 * @param isPressed boolean; default - false | this is option for control pressed state of button through event
 * @param disabled boolean; default - false
 * @param hasIconButton Default - NO_ICON;
 * Options: NO_ICON | LEADING_ICON - icon is left | TRAILING_ICON - icon is right | ICON_ONLY
 * @param colorSchema Default - BTN_LIGHT_THEME; Options: BTN_LIGHT_THEME | BTN_DARK_THEME
 * @param isDarkMode boolean; default - 'false'; TODO - need use this prop instead of 'colorSchema'
 * @param size Default - SIZE_36; Options: SIZE_36 | SIZE_40 | SIZE_44 | SIZE_48
 * @param iconComponent - icon component (expected svg-icon)
 * @param role - optional; All the WAI-ARIA 1.1 role attribute values from https://www.w3.org/TR/wai-aria-1.1/#role_definitions
 * @param isRightToLeft - optional; default - 'false'
 * @param isLoading boolean; default - false
 *
 * @returns ReactElement
 */
export function Button(props) {
    const { labelRef, buttonRef, label = '', width = '100%', type = 'button', isLoading = false, ...rest } = props;
    const buttonProps = {
        ...DEFAULT_BUTTON_PROPS,
        width,
        type,
        ...rest,
    };
    const { buttonVariant = CONTAINED_VARIANT, hasIconButton = NO_ICON, iconComponent, iconRotate, } = buttonProps;
    // not valid case for button component
    if (!label && hasIconButton === NO_ICON) {
        return null;
    }
    const ButtonComponent = getButtonComponent({
        buttonVariant,
    });
    if (isLoading) {
        return (React.createElement(ButtonComponent, { ...buttonProps, ref: buttonRef },
            React.createElement(SpinnerLoaderStyled, { size: SpinnerLoaderSizes.SMALL, isLoading: true, isWhite: true })));
    }
    if (hasIconButton !== NO_ICON) {
        return (React.createElement(ButtonComponent, { ...buttonProps, ref: buttonRef },
            React.createElement(ContentButtonWithIcon, { hasIconButton: hasIconButton, iconComponent: iconComponent, label: label, iconRotate: iconRotate, labelRef: labelRef })));
    }
    if (label) {
        return (React.createElement(ButtonComponent, { ...buttonProps, ref: buttonRef },
            React.createElement("span", { ref: labelRef }, label)));
    }
    return null;
}
